import * as m from './recipeMethods';
import { recipe, cleanRecipe } from './recipeData';
import * as elements from './UiElements';
import * as ui from './uiControllers/uiChanger';
import * as sUI from './uiControllers/summary';
import { Dough } from './data/Recipe';

// New Ingredient State Object
let newIngredient = {};

const init = () => {
  m.updateDoughStats();
  ui.emptyParent(elements.ingredientList);
  ui.updateIngQty(recipe.ingredients, elements.ingredientList);
  sUI.showSummary(recipe);
  newIngredient = {};
};

init();

/*******
 * Summary Section
 */
// Show Summary Editor
elements.summarySection.addEventListener('click', sUI.showSummaryChanger);
// Hide summary editor when user clicks cancel or savle
elements.summaryEditors.addEventListener('click', (e) => {
  if (e.target.classList.contains('input-box-cancel-cta')) {
    sUI.hideSummaryChanger();
  } else if (e.target.classList.contains('input-box-save-cta')) {
    saveSummaryInput();
  }
});

const saveSummaryInput = () => {
  if (elements.loafNumInput.value) {
    m.setLoafNum(elements.loafNumInput.value);
  }

  if (elements.loafMassInput.value) {
    const summaryNewMass = elements.loafMassInput.value;
    m.scaleDoughMass(summaryNewMass, recipe.numLoaves);
  }

  if (elements.loafHydrInput.value) {
    const newHydration = elements.loafHydrInput.value / 100;
    m.changeBakersHydration(newHydration);
  }
  init();
  sUI.hideSummaryChanger();
};

// Show & Hide Add Ingredient Modal
window.addEventListener('hashchange', ui.toggleModal); // listen for hash changes
elements.addIngButton.addEventListener('click', () => {
  newIngredient.isNewIng = true;
  ui.showIngModal();
});

elements.closeIngModal.addEventListener('click', () => {
  ui.hideIngModal();
  init();
});

const setNewIngBPct = () => {
  // if the new ingredient is flour, it needs to be added into the total
  let totalFlour = m.sumIngredientType('flour');
  if (newIngredient.isNewIng && newIngredient.type === 'flour') {
    totalFlour += newIngredient.qty;
  }
  const ingBpct = newIngredient.qty / totalFlour;
  newIngredient.BPct = ingBpct;
  if (newIngredient.BPct) {
    elements.newIngBPct.value = Math.round(newIngredient.BPct * 1000) / 10;
  }
};

// Listen for values in the TYPE setion of the modal
elements.newIngTypeParent.addEventListener('click', (cur) => {
  const clk = cur.target;
  newIngredient.type = cur.target.innerHTML.toLowerCase();
  if (clk.className.includes('cta')) ui.setButtonClick(clk);
  setNewIngBPct();
});

// Listen for values in the NAME setion of the modal
elements.newIngName.addEventListener('input', () => {
  newIngredient.name = elements.newIngName.value;
});

// Change Modal BPCT Based on Gram Quantity input
elements.newIngQty.addEventListener('input', (e) => {
  newIngredient.qty = parseInt(e.target.value);
  setNewIngBPct();
});

// Change Modal Gram Quantity input Based on BPCT Input
elements.newIngBPct.addEventListener('input', (e) => {
  let ingPct = parseInt(e.target.value) / 100;
  if (ingPct) {
    let ingQty;
    let totalFlour = m.sumIngredientType('flour');
    if (newIngredient.isNewIng && newIngredient.type === 'flour') {
      //
      ingQty = (ingPct * totalFlour) / (1 - ingPct);
    } else {
      ingQty = totalFlour * ingPct;
    }
    // update the new ingredient object and UI
    newIngredient.qty = ingQty;
    elements.newIngQty.value = Math.round(ingQty);
  }
});

// take modal inputs and update recipe
const saveIngredientChanges = () => {
  if (newIngredient.name && newIngredient.qty > 0 && newIngredient.type) {
    // edit the ingredient if it already exists in the recipe model
    if (m.getIngredientByName(newIngredient.name)) {
      m.modIngredient(newIngredient.name, newIngredient.qty);
    } else {
      m.addIngredient(
        // name, qty, type
        newIngredient.name,
        newIngredient.qty,
        newIngredient.type
      );
    }
    newIngredient = {};
    ui.hideIngModal();
    init();
  } else {
    alert(
      `Please add a type, name, and quantity in order to add your ingredient.`
    );
  }
};

// Listen for clicks on the modal save ingredient button
elements.saveIngButton.addEventListener('click', saveIngredientChanges);

// Edit Ingredient 1: Show Modal with values
elements.ingredientList.addEventListener('click', (cur) => {
  // get the target of the click
  try {
    // get the ingredient name
    const name = cur.target.dataset.ingredientName;
    // locate the ingredient in the data model
    let ing = m.getIngredientByName(name);
    // set values for the newIngredient state object
    newIngredient = ing;
    newIngredient.isNewIng = false;
    // add the ingredient to the modal and open it
    ui.addIngredientsToModal(ing.name, Math.round(ing.qty), ing.type);
    // set the bakers % field
    elements.newIngBPct.value = Math.round(newIngredient.BPct * 1000) / 10;
    ui.showIngModal();
    // show the delete button
    ui.showDeleteIngButton();
  } catch (error) {}
});

// Edit Ingredient 2: Delete Ingredient Event listener
elements.deleteIngButton.addEventListener('click', () => {
  m.deleteIngredient(newIngredient.name);
  init();
  ui.hideIngModal();
});

// event listeners for quantity section
// otherLoafQuantity;
// otherDoughMass;

//elements.otherDoughMass.addEventListener('click', ui.newDoughMass);

// Listen for key presses
window.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' || e.key === 'Esc') {
    if (!elements.overlay.classList.contains('hidden')) {
      ui.hideIngModal();
      init();
    }
    ui.hideNewInput();
  } else if (e.key === 'Enter') {
    if (!elements.overlay.classList.contains('hidden')) {
      saveIngredientChanges();
    } else {
      saveSummaryInput();
    }
  }
});

const dough = new Dough(
  cleanRecipe.ingredients,
  'Basic Sourdough',
  'My go-to weekday loaf.'
);
// dough.setLoafMass(800);
// dough.addIngredient('Water', 15, 'liquid');
// dough.changeIngredient('Whole Wheat Flour', 'name', 'Red Fife Freshly Milled');
// dough.changeIngredient('Red Fife Freshly Milled', 'qty', 150);
// dough.updateDoughInfo();
dough.ingredients[0].addUnits('g');
console.log(dough.ingredients);
console.log(dough.recipeInfo);
